import type { DateOrders } from 'src/modules/user/types/date-orders.types'

export const dateOrders: DateOrders = {
  MDY: 'M/d/R',
  DMY: 'd/M/R',
  YMD: 'R-M-d',
}
